<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
                    <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加用戶形象</el-button>
					
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
						</el-form-item>
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="角色" :value="1"></el-option>
								<el-option label="頭飾" :value="2"></el-option>
								<el-option label="稱號" :value="3"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">

				</el-table-column>
			<!-- 	<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
				
				<el-table-column align="center" prop="title" label="名稱">
				</el-table-column>


				<el-table-column align="center"  prop="type"  label="類型">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.type==1">角色</span>
						<span style="color: rgb(85, 178, 225);" v-if="v.row.type==2">頭飾</span>
						<span style="color: rgb(232, 196, 98);" v-if="v.row.type==3">稱號</span>
					</template>
				</el-table-column>
				

                <el-table-column align="center" prop="name" label="圖片">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>


				<el-table-column align="center" width="80" prop="content"  label="簡介">
					<template slot-scope="scope">
						<el-popover trigger="click" style="cursor: pointer;" placement="top">
						  <p style="width: 300px;">{{ scope.row.content }}</p>
						  <div slot="reference" class="name-wrapper">
							<el-tag size="medium">查看</el-tag>
						  </div>
						</el-popover>
					  </template>
				</el-table-column>

				<el-table-column align="center" prop="head_app" width="200" label="app圖片地址">
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
                <el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
		
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加形象':'修改形象'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'120px'" :label-position="layout.is_phone?'top':'left'">
				<el-form-item  label="發送類型" v-show="editIndex>0?false:true"  prop="sendtype">
					 <el-radio-group v-model="form.type" >
					    <el-radio :label="1">角色</el-radio>
					    <el-radio :label="2">頭飾</el-radio>
					    <el-radio :label="3">稱號</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item  label="默認贈送" prop="is_sel">
					 <el-radio-group v-model="form.is_sel" >
					    <el-radio :label="0">不贈送</el-radio>
					    <el-radio :label="1">贈送</el-radio>
					</el-radio-group>
				</el-form-item>

                <el-form-item  label="形象展示圖" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'5',cms_type:'1'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon" :src="form.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<el-form-item label="app圖片地址" prop="head_app">
					<el-input type="text" v-model="form.head_app" 
					placeholder="app圖片地址" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="形象名稱" prop="title">
					<el-input type="text" v-model="form.title" 
					placeholder="形象名稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				<el-form-item label="形象簡介" prop="content">
					<el-input type="textarea" :rows="8" v-model="form.content" 
					placeholder="形象簡介" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
              
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					title: [{
							required: true,
							message: "名稱不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "簡介不能為空",
							trigger: 'blur',
						},
					],
					
                    icon: [{
							required: true,
							message: "上傳形象圖片",
							trigger: 'blur',
						},
					
					],
                    head_app: [{
							required: true,
							message: "前端圖片地址不能為空",
							trigger: 'blur',
						},
					
					],
					
				},
                fullscreenLoading: false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					title: '',
					type:-1,
					time: [],
				},
				model_title: 'UserRole',
				auth_val: 'UserRole',
				preUrl: "data/UserRoleList", //列表地址
				delAllUrl: "data/delUserRoleAll", //批量删除地址
				delUrl: "data/delUserRole", //删除單条地址
                addUrl: "data/addUserRole", //添加/修改地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					appoint_id:0,
					type:1,
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
		
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
                
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
                this.fullscreenLoading.close();
			  },
            handleAvatarGifSuccess(res, file) {
                
				this.form.icon_gif = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head_gif = res.encryption.data.list.url
				}
                
                this.fullscreenLoading.close();
			},
			
			beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 50;
               
				if (!isJPG) {
				  this.$message.error('文件格式錯誤!');
                  return false;
				}
				
                this.fullscreenLoading = this.$loading({
                    lock: true,
                    text: '正在上傳圖片',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
               
				return isJPG && isLt2M;
			
			  },
			

			// 打开模态框
			openModel(e, type) {
                console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						type:e.type,
                        icon:e.head,
                        head_app:e.head_app,
                        head:e.head,
                        is_sel:e.is_sel,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						is_sel: 0,
                        type:1,
						title:'',
						content:"",
                        icon:'',
						head_app:'',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.page.current = 1;
				this.from = {
					title:'',
					type:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇圖片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
